import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cross, Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setMessage('Veuillez saisir votre adresse email.');
      setMessageType('error');
      return;
    }

    setIsSubscribing(true);
    setMessage('');

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
      const response = await fetch(`${API_URL}/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email: email.trim() })
      });

      const result = await response.json();

      if (result.success) {
        setMessage('Merci ! Vous êtes maintenant abonné(e) à notre newsletter 🌸');
        setMessageType('success');
        setEmail(''); // Vider le champ email
      } else {
        setMessage(result.message || 'Une erreur est survenue lors de l\'abonnement.');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Erreur newsletter:', error);
      setMessage('Une erreur est survenue. Veuillez réessayer plus tard.');
      setMessageType('error');
    } finally {
      setIsSubscribing(false);
      
      // Effacer le message après 5 secondes
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 5000);
    }
  };
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                {/* logo */}
                <img src="../assets/images/logo_FSF.png" alt="Logo FSF" className="w-9 h-9" />
                
                {/* <Cross className="w-6 h-6 text-white" /> */}
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold">FSF</h3>
                <p className="text-sm text-gray-300">Fleurs de la Sainte Famille</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed text-justify">
              Une communauté chrétienne catholique unie dans la foi, l'espérance et la charité. 
              Nous marchons ensemble sur le chemin de la sainteté, inspirés par l'exemple de la Sainte Famille.
            </p>
          </div>

          {/* Navigation rapide */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-600 text-justify">Navigation</h4>
            <ul className="space-y-2 text-gray-300 text-justify">
              <li>
                <Link to="/" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                 - Accueil
                </Link>
              </li>
              <li>
                <Link to="/galerie" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Galerie
                </Link>
              </li>
              <li>
                <Link to="/ressources" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Ressources
                </Link>
              </li>
              <li>
                <Link to="/evenements" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Événements
                </Link>
              </li>
              <li>
                <Link to="/prieres" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Prières
                </Link>
              </li>
              <li>
                <Link to="/don" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Faire un don
                </Link>
              </li>
            </ul>
          </div>

          {/* Ressources spirituelles */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-600 text-justify">Ressources</h4>
            <ul className="space-y-2 text-gray-300 text-justify">
              <li>
                <a href="./eglise-catholique-benin" target='_blank' className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Église Catholique Bénin
                </a>
              </li>
              <li>
                <a href="./prieres" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Prères
                </a>
              </li>
              <li>
                <a href="./evenements" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Evènements
                </a>
              </li>
              <li>
                <a href="./galerie" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Galerie
                </a>
              </li>
              <li>
                <a href="./ressources" className="hover:text-blue-400 text-gray-100 transition-colors duration-200">
                  - Bibliothèque spirituelle
                </a>
              </li>
            </ul>
          </div>

          {/* Contact et réseaux sociaux */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-600 text-justify">Contact</h4>
            <div className="space-y-3 text-justify">
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail className="w-4 h-4 text-blue-400" />
                <span className="text-sm">contact@fleursdelasaintefamille.org</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-sm">+229 01 97 08 46 01</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="text-sm">Paroisse Jésus Eucharistie <br />Cotonou, <br />Bénin</span>
              </div>
            </div>

            {/* Réseaux sociaux */}
            <div className="mt-6">
              <h5 className="text-sm font-bold mb-3 text-justify">Suivez-nous</h5>
              <div className="flex space-x-3">
                <a href="#" className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200">
                  <Facebook className="w-4 h-4 text-white" />
                </a>
                <a href="#" className="w-8 h-8 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors duration-200">
                  <Instagram className="w-4 h-4 text-white" />
                </a>
                <a href="#" className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors duration-200">
                  <Youtube className="w-4 h-4 text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Section newsletter */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="max-w-2xl mx-auto text-center">
            <h4 className="text-xl font-bold mb-4">Restez connectés à notre communauté</h4>
            <p className="text-gray-300 mb-6">
              Recevez nos événements, actualités et intentions de prière directement dans votre boîte mail.
            </p>
            
            {/* Formulaire newsletter */}
            <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre adresse email"
                  disabled={isSubscribing}
                  className="flex-1 px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 disabled:opacity-50"
                />
                <button 
                  type="submit"
                  disabled={isSubscribing}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                >
                  {isSubscribing ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                      Abonnement...
                    </>
                  ) : (
                    'S\'abonner'
                  )}
                </button>
              </div>
            </form>

            {/* Message de feedback */}
            {message && (
              <div className={`mt-4 p-3 rounded-lg text-sm ${
                messageType === 'success' 
                  ? 'bg-green-600/20 border border-green-600/50 text-green-300' 
                  : 'bg-red-600/20 border border-red-600/50 text-red-300'
              }`}>
                {message}
              </div>
            )}
            
            <p className="text-xs text-gray-400 mt-3">
              Vos données sont protégées. Vous pouvez vous désabonner à tout moment.
            </p>
          </div>
        </div>

        {/* Bas de page */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Fleurs de la Sainte Famille (FSF). Tous droits réservés.
              </p>
              <p className="text-gray-400 text-xs mt-1">
                "Que tout soit fait avec amour" - 1 Corinthiens 16:14
              </p>
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/legal-mentions" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Mentions légales
              </Link>
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Politique de confidentialité
              </Link>
              {/* <Link to="/sitemap" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Plan du site
              </Link> */}
            </div>
          </div>
        </div>
      </div>

      {/* Version du Vatican News */}
      <div className="bg-gray-900 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
            <p>
              Contenus liturgiques fournis par AELF - Communauté Épiscopale Liturgique pour les pays Francophones
            </p>
            <p className="mt-2 sm:mt-0">
              En communion avec l'Église universelle et le Saint-Siège
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;